import {useState} from 'react'
import './Counter.css'
import { useEffect } from 'react'

const Counter = ({maxValue,minValue,setMaxNumber}) => {


    const [Value,setValue]=useState(minValue)
   
    function Decrement(e) {
        const NewValue=Value-1

        if (Value>minValue) {

            setValue(NewValue)
            setMaxNumber(NewValue)
            e.currentTarget.classList.remove('disable')
           
            
        } else {

            //e.currentTarget.innerText="Min."
            e.currentTarget.classList.add('disable')
            //e.currentTarget.innerText="Min."

            
        }
 
    }

     function Increment(e) {
        const NewValue=Value+1

        if (Value<maxValue) {

            setValue(NewValue)
            setMaxNumber(NewValue)

            e.currentTarget.classList.remove('disable')
            
        } else {

           // e.currentTarget.innerText="Max."
           e.currentTarget.classList.add('disable')
           //e.currentTarget.innerText="Max."
            
        }
 
    }
    const HandleInput = (e) => {
        const inputValue = Number(e.currentTarget.value); 

        if (inputValue < minValue) {
            setValue(minValue);
        } else if (inputValue > maxValue) {
            setValue(maxValue);
        } else {
            setValue(inputValue);
        }
    };

  
    useEffect(
        ()=>{

        setMaxNumber(Value)

        },[]
    )
    useEffect(
        ()=>{

            
            if (Value>minValue) {
                
                document.querySelector('.btn1').classList.remove('disable')
               //
               // document.querySelector('.btn1').innerText="-"

            }

            if (Value<maxValue) {
                    
                document.querySelector('.btn2').classList.remove('disable')
                //document.querySelector('.btn2').innerText="+"

            }

        },[Value,minValue,maxValue]
    )


  return (
    <div id='Counter'>
        <div className='CounterContainer'>
            <button className='btn1' onClick={e=>Decrement(e)}>-</button>
            <input className='counter_input' type="number" value={Value} onChange={e=>HandleInput(e)}/>
            <button className='btn2' onClick={e=>Increment(e)}>+</button>
        </div>
    </div>
  )
}

export default Counter